import { H3Text } from '@prisjakt/ui/text/variants';
import React from 'react';
import { Accordion, AccordionContent, AccordionHeader } from 'src/ui/accordion';
import { useAppContext } from 'src/components/app-context';
import type { Faq, Maybe } from 'src/types';

export const ProductFAQ: React.FC<ProductFAQProps> = props => {
  const { t } = useAppContext();
  return (
    <div>
      <H3Text>{t('common', 'text.faq')}</H3Text>
      {props.items.filter(Boolean).map(item => (
        <Accordion key={item!.id} id={item!.id.toString()}>
          <AccordionHeader>{item!.question!}</AccordionHeader>
          <AccordionContent>{item!.answer!}</AccordionContent>
        </Accordion>
      ))}
    </div>
  );
};

interface ProductFAQProps {
  items: Maybe<Faq>[];
}
